import React, {Component} from 'react';
import {scrollTop} from "../../utils/helpers";
import './PrivacyPolicy.css';

class PrivacyPolicy extends Component {


    componentDidMount() {
        scrollTop();
    }


    render() {
  

        return (
            <section id="privacy-policy-page">
                <div className="container">

                <p>
                    <h2><b>Privacy Notice</b></h2>
                </p>

                <p>
                    <h4><b>Cookies are files saved on your phone, tablet, or computer when you visit a website. We use cookies to store information about how you use the HRRP Nepal website, such as the pages you visit.</b></h4>
                </p>

                <p>
                HRRP Nepal respects your privacy and is committed to protecting your personal data. This Notice explains when and how we collect your personal data when you use our website and the rights you have over your own information.
                </p>

                <p>
                This Notice applies to the website of HRRP Nepal International, however, when you use this site, you may be directed to the website of other members of the HRRP Nepal confederation or links to third-party websites or applications. These websites will have their own Privacy Notices, which you should also look at.
                </p>

                <p>
                If you have any questions in relation to this Notice or would like to exercise your rights under it, please contact:
                </p>

                <p>
                privacy@hrrpnepal.org
                </p>

                <p>
                    <h4><b>
                    Information about who we are
                    </b></h4>
                </p>

                <p>
                The Housing Recovery and Reconstruction Platform (HRRP) was established in December 2015 to take over supporting coordination of the post-earthquake housing reconstruction from the Nepal Shelter Cluster, as it returned to the pre-earthquake format as a standard cluster. HRRP provides coordination support services for the National Reconstruction Authority (NRA), 
Building and Grant Management and Local Infrastructure (GMALI) Central Level Programme Implementation Units (CLPIUs), other relevant government authorities, and Partner Organizations (POs). HRRP3 is primarily funded by DFID Nepal and CRS Nepal.

                </p>


                <p>
                Further information and details of our registration with data protection supervisory authorities are detailed below.
                </p>

                <p>
                    <h4><b>How our website works</b></h4>
                </p>

                <p>
                When you visit our website, we collect data on your location. We also use cookies on our website to collect standard internet log-on information and details of visitor behavior patterns (e.g. to find out the number of visitors to different parts of the site). 
                </p>

                <p>
                This enables us to analyze and improve the content of our site and the navigation experience of users. We do not use this information to attempt to find out the identities of those visiting our website. 
                </p>

                <p>
                Some cookies on our site also permit third parties to analyze visitor behavior to display advertising. These parties also do not use this information to attempt to find out the identities of individuals. 
                </p>

                <p>
                For full details of the cookies used on our website, see our Cookies Notice. You can disable or delete some or all cookies in your browser setting, although this may affect some parts of the site’s functionality.
                </p>

                <p>
                    <h4><b>The data we collect about you</b></h4>
                </p>

                <p>
                There are several areas on our website where you may provide personal data to HRRP Nepal including when you:
                </p>

                <p>
                i. Subscribe for HRRP Nepal email newsletter 
                </p>

                <p>
                ii. Signing into user portal.  
                </p>

                <p>
                iii. Submit Reconstruction Stories to HRRP Team
                </p>

                <p>
                The information we collect will depend on the nature of your action but may include name, email address, telephone number preference. When you provide your information to us, we will only use the information for the purposes for which it is provided, for any compatible purposes and to fulfil our legal or regulatory obligations unless you have agreed for your data to be used for other purposes.
                </p>
                
                <p>
                    <h4><b>
                    When will we send you newsletter communications?
                    </b></h4>
                </p>

                <p>
                We will only contact you for reconstruction update purposes (for example keep you up to date on our reconstruction work based, or let you know of ways in which you can support that work) where we have your consent.
                </p>

                <p>
                At each place that you provide your personal data on our website, there is an opportunity for you to express your preferences in relation to communications from us. Where you provide your consent to such communications, you can withdraw consent or change your preferences at any time by clicking the unsubscribe button on any reconstruction communication or by sending an email to privacy@hrrpnepal.org expressing your preferences.
                </p>

                <p>
                We will generally treat any consent you give us as lasting for 5 years, as we have found our supporters may get involved with different campaigns at different points over this period.
                </p>

                <p>
                We never sell or share your information with entities outside HRRP Nepal for their marketing purposes.
                </p>

                <p>
                    <h4><b>Links to other Affiliate websites</b></h4>
                </p>    

                <p>
                For some actions that you may like to take when visiting our website, you will be redirected to the other website of an HRRP Nepal marked as an important links and social media pages. 
                and you should look at their Privacy Notice to understand how they will use your data, and your rights. This includes where:
                <a href="http://nra.gov.np/" target="_blank">http://nra.gov.np/</a> ,
                <a href="http://moud.gov.np/" target="_blank">http://moud.gov.np/</a> ,
                <a href="http://www.mofald.gov.np/" target="_blank">http://www.mofald.gov.np</a> ,
                <a href="https://housecostcalculator.app/" target="_blank">https://housecostcalculator.app/ </a> ,
                <a href="https://www.nset.org.np/nset2012/" target="_blank">https://www.nset.org.np/nset2012/ </a> ,
                <a href="https://www.crs.org/our-work-overseas/where-we-work/nepal" target="_blank">https://www.crs.org/our-work-overseas/where-we-work/nepal</a> ,
                       and 
                       <a href="https://www.gov.uk/world/organisations/dfid-nepal" target="_blank">https://www.gov.uk/world/organisations/dfid-nepal</a> ,
                        
                </p>

                <p>
                    <h4><b>
                    Who might we share your information with?
                    </b></h4>
                </p>

                <p>
                We may share your information with members of the HRRP Nepal Team and Donors. We may also share your information with third parties who process data on our behalf, but only where we place obligations on them in relation to the security of the data and require them to use the data only as we instruct. 
                </p>

                <p>
                If you are in the European Union, and your personal data is transferred to an HRRP Nepal Affiliate, this will occur under a safeguard mechanism recognized by the European Commission as providing adequate protection for your personal data.  
                </p>

                <p>
                Transfers to HRRP Nepal Affiliates will occur under the EC’s model data protection clauses.  You may ask to see a copy of these clauses.
                </p>

                <p>
                Transfers of your data to other third parties outside the EEA, or to third parties outside any other jurisdiction in which you are located, will occur in accordance with local data protection laws.
                </p>

                <p>
                    <h4><b>
                    Your Data and social media
                    </b></h4>
                </p>

                <p>
                This section refers to the ability for you to like, re-tweet, share, etc. HRRP Nepal International content on social media platforms, such as Facebook
                 <a href="https://www.facebook.com/HRRPNepal/"> https://www.facebook.com/HRRPNepal/ </a>,
                  Twitter <a href="https://twitter.com/HRRP_Nepal">https://twitter.com/HRRP_Nepal </a> ,
                   Flickr <a href="https://www.flickr.com/photos/hrrp"> https://www.flickr.com/photos/hrrp </a> ,
                    Flipboard <a href="https://flipboard.com/@HRRP"> https://flipboard.com/@HRRP </a> ,
                     and YouTube 
                     <a href="https://www.youtube.com/channel/UCQ86jWAJEmbEYbxyjCvrCFQ/featured"> https://www.youtube.com/channel/UCQ86jWAJEmbEYbxyjCvrCFQ/featured</a> . 
                </p>


                <p>
                Additionally, when using our website, you can link through to such social media sites.
                </p>

                <p>
                When you do this, depending on your privacy settings, these networks will adjust their marketing to show you more HRRP Nepal and/or HRRP Nepal-type content.  To change your settings on these services, please refer to their privacy notices, which will tell you how to do this.
                </p>

                <p>
                    <h4><b>Children’s Data</b></h4>
                </p>

                <p>
                Our website is not intended for use by children, and we do not knowingly collect data on children.
                </p>

                <p>
                    <h4><b>HRRP Nepal and social media</b></h4>
                </p>


                <p>
                Many social media sites provide, or permit, tools that aggregate and highlight content that appears on their site. HRRP Nepal uses such tools to analyze and assess the success of HRRP Nepal campaigns and communications, the level of interest in issues HRRP Nepal cares about, and the level of social media activity resulting from media stories about HRRP Nepal activities. We use the native reporting tools of the social media networks but may also use third-party tools.  HRRP Nepal uses such tools to respond directly to other users’ queries and comments related to HRRP Nepal.
                </p>

                <p>
                    <h4><b>
                    How do we protect your data?
                    </b></h4>
                </p>

                <p>
                We ensure that there are appropriate technical controls in place to protect your personal details. For example, our online forms are always encrypted, and our network is protected and routinely monitored.
                </p>


                <p>
                We undertake regular reviews of who has access to information that we hold to ensure that your information is only accessible by appropriately trained staff, volunteers, and contractors.
                </p>

                <p>
                In case, we use external companies to collect or process personal data on our behalf, we put a contract in place that sets out our expectations and requirements in relation to security of the data they access or process.
                </p>

                <p>
                These organizations - referred to as "Data Processors" also have legal liability for the way in which your data is used, providing you with additional protection.
                </p>

                <p>
                    <h4><b>
                    How long do we keep your data?
                    </b></h4>
                </p>

                <p>
                We will only retain the data you provide to us through our website for as long as required by applicable laws or as is necessary for the purpose for which it was collected and in accordance with any consents provided.
                </p>

                <p>
                We will delete personal data at the end of this period unless we wish to use it for statistical purposes, in which case we will anonymize it, such that you could never be re-identified with it.
                </p>

                <p>
                    <h4><b>
                    Your Rights
                    </b></h4>
                </p>

                <p>
                You have the right to request details of the information we hold about you. If you would like a copy of some or all your personal information, please make a request to our Data Protection Officer at the details provided below. 
                </p>

                <p>
                We will provide this information to you without charge, unless requests are manifestly unfounded, repetitive, or excessive, in which case we are entitled to charge an administration fee.
                </p>

                <p>
                You also have a right to have inaccurate information we hold about you rectified or removed and a right, in some circumstances, to restrict or object to us processing your information, or to seek erasure of your data. 
                </p>

                <p>
                If you believe we are not respecting your rights, you are entitled to make a complaint to a relevant supervisory authority.
                </p>

                <p>
                The legal basis on which we hold and use your data will vary depending on the activity involved. In some cases, we might hold the data because it is needed to fulfill a contract or meet our legal obligations. In others because it is in HRRP Nepal’s legitimate interest to do so, and in others, because you have consented to this use. We note that the legal basis on which we process your data will influence your specific rights.
                </p>

                <p>
                    <h4><b>Changes to this Notice</b></h4>
                </p>

                <p>
                   We may make changes to this notice from time to time. We will always detail, at the end of this notice, the date it was last updated, and you should check back from time to time.
                </p>

                <p>
                    <h4><b>HRRP Nepal Contact Details:</b></h4>
                </p>

                <p>
                Housing Recovery & Reconstruction Platform 
                </p>

                <p>
                Jwagal Road, Lalitpur Metropolitan City Ward No.10, Province 3, Nepal
                </p>

                <p>
                Phone:  +977-1-5544149
                </p>

                <p>
                Email: info@hrrpnepal.org
                </p>

                <p>
                This Privacy Policy was last updated on 31st July 2021.
                </p>

                </div>
            </section>
        )
    }
}

// const mapStateToProps = state => {
//     return {
//         gallery: state.gallery
//     };
// }

export default PrivacyPolicy;
